export default __webpack_public_path__ + "locales/tr/DeleteDialog.json?hash=f4879badb492d6d62429c3d2294e88be";